import { render, staticRenderFns } from "./ContractParagraphsField.vue?vue&type=template&id=b26ef568&scoped=true&"
import script from "./ContractParagraphsField.vue?vue&type=script&lang=ts&"
export * from "./ContractParagraphsField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26ef568",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
